import useRenderingKind from './renderingKindAtom';

export * from './renderingKindAtom';

export default useRenderingKind;
